<template>
    <div class="absolute w-full h-4 bottom-1 px-2 z-10">
        <div class="w-full relative pr-4 h-4 text-xs">
            <div class="h-1 border border-gray-100 rounded absolute top-1.5 w-full"></div>
            <div class="h-1 border border-gray-100 rounded bg-green-400 absolute top-1.5 w-full"
                 :style="'width:'+percent"></div>
            <div class="w-full absolute top-0" style="padding-left:0rem; padding-right:2rem;">
                <div
                    class="top-0 h-4 bg-white w-8 border border-gray-300 bg-white rounded align-text-top text-gray-400 text-xs m-0 py-0 px-1 h-4"
                    :style="'line-height:0.95rem; margin-left:'+percent"
                    v-text="percent"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        percent: String,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {},
    async mounted() {
    },
}
</script>
